import { LoginScopeEntry, WebsiteScopeEntry, WindowsDesktopAppScopeEntry } from 'persistable-types';

import getWebsiteAttributesEntry from './getWebsiteAttributesEntry';
import { normalizeWebsitePattern } from './normalizeWebsitePattern';

export default function normalizeLoginScopeEntry(scope: LoginScopeEntry): LoginScopeEntry {
  switch (scope.kind) {
    case 'website':
      return normalizeWebsiteScopeEntry(scope);
    case 'windowsDesktopApp':
      return normalizeWindowsDesktopAppScopeEntry(scope);
    default:
      return scope;
  }
}

export function normalizeWebsiteScopeEntry(scope: WebsiteScopeEntry): WebsiteScopeEntry {
  const normalizedWebsitePattern = normalizeWebsitePattern(scope.pattern);
  const attributesFromPattern = getWebsiteAttributesEntry(scope.pattern);
  return {
    ...scope,
    ...attributesFromPattern,
    pattern: normalizedWebsitePattern,
  };
}

export function normalizeWindowsDesktopAppScopeEntry(
  scope: WindowsDesktopAppScopeEntry,
): WindowsDesktopAppScopeEntry {
  return {
    ...scope,
    exeName: normalizeExeName(scope.exeName),
  };
}

export function normalizeExeName(exeName: string): string {
  return exeName.trim().toLowerCase();
}
